export function shareOnFacebook(url: string) {
    const u = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(u, "_blank_fb_share");
}
